import {
    AfterViewInit,
    Component,
    ElementRef,
    HostListener,
    Inject,
    Input,
    OnChanges,
    OnInit,
    Renderer2,
    ViewChild,
    ChangeDetectorRef
} from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { environmentsActions } from '@src/store/reducers/environmentsReducer';
import { projectsActions } from '@src/store/reducers/projectsReducer';
import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { Utils } from '@src/utils/util';
import { MatSort } from '@angular/material/sort';
import { packagesActions } from '@src/store/reducers/packagesReducer';
// import { E } from '@angular/cdk/keycodes';
// import { Cipher } from 'crypto';

export interface IDeployedPackagesTable {
    packageName: string;
    isAdhocPackage: boolean;
    entityType: string;
    projectId: number;
    id: number;
    tags: string;
    executedBy: string;
    started: string;
    action: string;
}
@Component({
    selector: 'deployed-packages-data',
    template: require('./deployed-packages-data.component.html'),
    styles: [require('./deployed-packages-data.component.scss')]
})
export class DeployedPackagesDataComponent implements OnInit, OnChanges, AfterViewInit {
    public projectId: any;
    public dplModeType: any;
    public environmentId: string;
    private envDetail: any;
    private renderComp: boolean;
    @Input() public isHistory: boolean = false;
    @Input() public get data() {
        return this._data;
    }
    public criteria: any = { data: { fromDate: null, toDate: new Date(), filterText: '', selectedFilterOption: 2 } , isHistory: this.isHistory }
    public set data(value) {
        if (value) {
            this._data = value;
            const data = [];
            value.forEach((item) => {
                const date = `${item.deployedOnDate}`;
                item.deployedOnDate = this.utils.convertUTCtoLocalWithoutFormat(date);
                item.tagsNames = item.tags ? item.tags.map(m => m.displayName).join(', ') : '';
                data.push({tags: item.tags,
                    packageName: item.name,
                    projectId: item.ProjectId,
                    id: item.id,
                    entityType: item.entityType,
                    isAdhocPackage: item.isAdhocPackage,
                    started: item.deployedOnDate,
                    executedBy:item.deployedUserName});
            });
            this.dataSource.data = data;
            this.toggleColumn();
        }
    }
    // tslint:disable-next-line:variable-name
    private _data: any;

    public displayedColumns = ['packageName', 'tags', 'executedBy', 'started', 'action'];
    public dataSource = new MatTableDataSource<IDeployedPackagesTable>([]);
    @ViewChild(MatSort) public sort: MatSort;

    private pressed = false;
    private currentResizeIndex: number;
    private startX: number;
    private startWidth: number;
    private isResizingRight: boolean;
    private resizableMousemove: () => void;
    private resizableMouseup: () => void;

    @ViewChild(MatTable, { read: ElementRef }) private matTableRef: ElementRef;
    private columns: any[] = [
        { field: 'packageName', width: 400  },
        { field: 'tags', width: 150 },
        { field: 'executedBy', width: 190 },
        { field: 'started', width: 190 },
        { field: 'action', width: 50 }];

    constructor(@Inject('$state') private $state: any,
                private store: Store,
                @Inject('$stateParams') stateParams: any,
                private dialogManagerService: DialogManagerService,
                private utils: Utils,
                private renderer: Renderer2,
                private cdr: ChangeDetectorRef
          
    ) {
        this.projectId = stateParams.id;
        this.environmentId = stateParams.envID;
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
            case 'started':
                return new Date(item.started);
            default:
                return item[property];
            }
        };
    }

    ngOnChanges(){
      if( this.renderComp){
        this.cdr.detectChanges();
      }
    }

    public async ngOnInit() {
        if (!this.store.getState().environments.envDetails.environments) {
            await this.store.dispatch({ type: environmentsActions.GET_ENV_DETAILS, payload:
                    { projectId: this.projectId, envId: this.environmentId } });
        }
        this.envDetail = this.store.getState().environments.envDetails;
        if (!this.store.getState().projects.projectWithMetaData ||
            (this.store.getState().projects.projectWithMetaData &&
                this.store.getState().projects.projectWithMetaData.id !== this.projectId)) {
            const projectMetaData = await this.store.dispatch({ type: projectsActions.GET_PROJECT_META_DATA,
                payload: { projId: this.projectId } });
            const data = { ...projectMetaData.data };
            this.dplModeType = this.store.getState().enums.DeployModeTypes[data.dplModeType];
        } else {
            this.dplModeType = this.store.getState().
                enums.DeployModeTypes[this.store.getState().projects.projectWithMetaData.dplModeType];
        }
        setTimeout(() => {
            this.dataSource.sort = this.sort;
        });
        this.toggleColumn();
    }

    public ngAfterViewInit() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }



    public deleteDeployedPackage(entity) {
        const onConfirm = () => {
            const payload = {
                projectId: this.projectId,
                environmentId: this.environmentId,
                packageId: entity.id
            };
            this.store.dispatch({ type: packagesActions.DELETE_DEPLOYED_PACKAGE, payload: payload }).then(value => {
                if(value){
                    this.getRecords()
                }
            })
            
            // this.dataSource.data
            // const data = this.store.dispatch({ type: packagesActions.GET_EFFECTIVE_DEPLOYED_PACKAGES, payload: { id: this.projectId } });
            // console.log(data)
        };
        const dialogData = { title: 'Delete a Deployed Package', action: 'delete', item: entity.name };
        this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
    }


    public getRecords (page = 0) {
        const pageNumber = page || 0;
        const payload = {
            pageNumber,
            startDate: this.criteria.data.fromDate,
            endDate: this.criteria.data.toDate,
            filterText: this.criteria.data.filterText,
            projectId: this.projectId,
            environmentId: this.environmentId,
            pageSize: 50,
            filterOption: this.criteria.data.selectedFilterOption
        };
        let type = packagesActions.GET_EFFECTIVE_DEPLOYED_PACKAGES;
        if (this.isHistory === true) {
            type = packagesActions.GET_EFFECTIVE_DEPLOYED_PACKAGES_HISTORY;
        }
        this.store.dispatch({ type, payload }).then((res) => {
            if (res) {
                this.data = res.data
            }
        });
    }

    public navigate(event: any, sref: any, params: any) {
        event.preventDefault();
        this.$state.go(sref, params);
    }

    private toggleColumn() {
        const i = this.displayedColumns.indexOf('action');
        const isAction: boolean = this.isActionColumnVisible();
        if (isAction && i === -1) {
            this.displayedColumns.push('action');
            this.columns.push({ field: 'action', width: 50 });
        }
        if (!isAction && i > -1) {
            this.displayedColumns.splice(i, 1);
            this.columns.splice(i, 1);
        }
    }

    public isActionColumnVisible (): boolean {
        if (!(this.envDetail && this.envDetail.environments)) {
            return false;
        }
        const environment = this.envDetail.environments.find(m => m.id.toString() === this.environmentId);
        if (!environment) {
            return false;
        }
        return !this.isHistory && this.dplModeType === 'ByTask' && !environment.isManaged && !environment.isRMSource;
    }

    private setTableResize(tableWidth: number) {
        let totWidth = 0;
        this.columns.forEach((column) => {
            totWidth += column.width;
        });
        const scale = (tableWidth - 5) / totWidth;
        this.columns.forEach((column) => {
            column.width *= scale;
            this.setColumnWidth(column);
        });
    }

    public onResizeColumn(event: any, index: number) {
        this.checkResizing(event, index);
        this.currentResizeIndex = index;
        this.pressed = true;
        this.startX = event.pageX;
        this.startWidth = event.target.clientWidth;
        event.preventDefault();
        this.mouseMove(index);
    }

    private checkResizing(event, index) {
        const cellData = this.getCellData(index);
        if ((index === 0) ||
            (Math.abs(event.pageX - cellData.right) < cellData.width / 2 && index !== this.columns.length - 1)) {
            this.isResizingRight = true;
        } else {
            this.isResizingRight = false;
        }
    }

    private getCellData(index: number) {
        const headerRow = this.matTableRef.nativeElement.children[0];
        const cell = headerRow.children[0].children[index];
        return cell.getBoundingClientRect();
    }

    private mouseMove(index: number) {
        this.resizableMousemove = this.renderer.listen('document', 'mousemove', (event) => {
            if (this.pressed && event.buttons) {
                const dx = (this.isResizingRight) ? (event.pageX - this.startX) : (-event.pageX + this.startX);
                const width = this.startWidth + dx;
                if (this.currentResizeIndex === index && width > 50) {
                    this.setColumnWidthChanges(index, width);
                }
            }
        });
        this.resizableMouseup = this.renderer.listen('document', 'mouseup', () => {
            if (this.pressed) {
                this.pressed = false;
                this.currentResizeIndex = -1;
                this.resizableMousemove();
                this.resizableMouseup();
            }
        });
    }

    private setColumnWidthChanges(index: number, width: number) {
        const orgWidth = this.columns[index].width;
        const dx = width - orgWidth;
        if (dx !== 0) {
            const j = (this.isResizingRight) ? index + 1 : index - 1;
            const newWidth = this.columns[j].width - dx;
            if (newWidth > 50) {
                this.columns[index].width = width;
                this.setColumnWidth(this.columns[index]);
                this.columns[j].width = newWidth;
                this.setColumnWidth(this.columns[j]);
            }
        }
    }

    private setColumnWidth(column: any) {
        const columnEls = Array.from(document.getElementsByClassName(`mat-column-${column.field}`));
        columnEls.forEach((el: HTMLDivElement) => {
            const packageNameElement = Array.from(el.getElementsByClassName('dp-package-name'));
            if (packageNameElement && packageNameElement.length > 0) {
                const el1: HTMLElement  = packageNameElement[0] as HTMLElement;
                el1.style.width = `${column.width}px`;
            }
            el.style.width = `${column.width}px`;
        });
    }

    @HostListener('window:resize', ['$event'])
    public onResize() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }

    public getTagsName(tags: any): string {
        return tags.map(t => t.displayName).join(',');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/deployed-packages/deployed-packages-data/deployed-packages-data.component.ts